import { Controller } from "@hotwired/stimulus"

// Forwards a click anywhere on a list row to that row's name link, which stays
// the keyboard target. Clicks on links, buttons and inputs keep their own
// meaning, and modified clicks (cmd, ctrl, shift, alt, middle) do nothing.
export default class extends Controller {
  static targets = [ "link" ]

  open(event) {
    if (event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.target.closest("a, button, input, select, textarea, label")) return

    // A table row, or the card rui_table renders for it on small screens.
    const row = event.target.closest("tr, [data-row-id]")
    const link = this.linkTargets.find((target) => row?.contains(target))
    link?.click()
  }
}
